import React from 'react';
import I18n from 'i18n-js';
import type { FormattedString, TagType } from '../../types';
import { RCTextInput } from '../RCTextInput';
import EmailValidationHelper from '../../../components/helpers/email_validation_helper';

interface Props {
  /** ID of the input component, must be unique across the page */
  id: string;

  /** html attr, used by html form submission */
  name: string;

  /** Main label text (or more complex components if you really need to) */
  label: FormattedString;

  disabled?: boolean;

  /** Signals to browser's form validator that a non-empty value must be selected */
  required?: boolean;

  /** Validation error message */
  errorText?: string;
  /** Additional info displayed below label */
  helpText?: FormattedString;

  /** Annotation on the field, e.g. 'required', 'optional' */
  tag?: TagType;

  /** called when value changes; updated value in evt.target.value */
  onChange: React.ChangeEventHandler<HTMLInputElement>;

  /** called when input element loses focus */
  onBlur?: React.FocusEventHandler<HTMLInputElement>;

  /** Current value of the input */
  value: string;

  /** Text that appears when the value is empty */
  placeholder?: string;
}

function validationErrorText(inputValue: string) {
  // no need to tell the user their email is invalid if they haven't typed anything
  if (!inputValue) {
    return '';
  }

  if (!EmailValidationHelper.isEmailValid(inputValue)) {
    return I18n.t('commons.signupForm.emailValidationError');
  }
  return '';
}

/**
 * Special version of RCTextInput with realtime email validation
 */
export function RCEmailInput(props: Props) {
  return (
    <RCTextInput
      {...props}
      errorText={props.errorText || validationErrorText(props.value)}
      type="email"
      autoComplete="email"
    />
  );
}
